/**
 * 收费服务迁移后-老页面失效 路由匹配检查
 */

// 需要检查的路由
const svRouters = [
	'/introduce',
	'/externalOrder',
	'/combine',
	'/exclusive',
	'/policyTrusteeship',
	'/policyOrder',
	'/placeSuccess',
	'/policyOrderSuccess',
	'/certficateAll',
	'/yyhdyy',
	'/yyhdPay',
	'/yyhdSuc',
	'/yyhdzp',
	'/companyIndex',
	'/companyInput',
	'/recordResult'
]

// 收费服务迁移后-老页面失效 路由匹配检查
export const svMigrationMatch = (to,next) => {
  if(!to) return false
	const { path, name } = to
	console.log(`path:${path};name:${name}`)
	if(!path) return false
	if(name === 'migration') return false
	const isMatch = svRouters.some(e => path.match(e) ? true : false)
	if(isMatch){
		next({
			path:'/migration'
		})
		return true
	}
	return false
}


// WEBPACK FOOTER //
// ./src/utils/svMigration.js